<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

@if (isAdvancedPlan && cloudRepos.length) {
  <div>
    <xrx-select
      inlineLabel="SDE_SELECT_REPOSITORY"
      type="group"
      [list]="inputSources"
      localize="key"
      property="key"
      [(selectedItem)]="selectedInputSource"
      (change)="selectInputSource($event)"></xrx-select>
  </div>
}
<!-- Local Drive Input -->
@if (inputSource.value === 'SDE_LOCAL_FILE') {
  <div class="pt-3">
    <xrx-multi-file-select
      [(ngModel)]="input.uploadFiles"
      maxFiles="{{ this.maxSelection }}"
      minFiles="{{ this.minSelection }}"
      mode="batch"
      maxFilesSelectedError="ZZ_SDE_MAXIMUM_FMTSTR_FILES_SELECTED"
      name="inputMultiSelect"
      id="inputMultiSelect"
      [sortable]="false"
      fileTypes="{{ input.fileTypes.asString }}"
      [fileTypesAccepted]="input.fileTypes.asAccept || ''"
      (fileDropped)="handleUploadFileInputs($any($event))">
    </xrx-multi-file-select>
  </div>
}

@if (inputSource.value !== 'SDE_LOCAL_FILE') {
  <div class="input-cloud-choice">
    <div>
      @for (cdoc of input.cloudRepoInputs; track cdoc; let i = $index) {
        <div class="selected-cloud-folder form-inline">
          <div
            class="form-control d-flex align-items-center"
            [ngClass]="{
              'is-invalid': hasSpecialCharacters(cdoc.file?.name || ''),
            }">
            <div class="truncate-txt">{{ cdoc.file?.name }}</div>
          </div>
          <button
            type="button"
            class="xrx-btn btn-secondary ml-2 modal-show-desktop"
            (click)="addChangeCloudInput(cdoc)"
            xdaTranslate>
            SDE_CHANGE
          </button>
          <button
            type="button"
            class="xrx-btn btn-secondary btn-short xgl-change modal-show-mobile"
            (click)="addChangeCloudInput(cdoc)"></button>
        </div>
      }
      <!-- blank row -- Add -->
      @if (
        !input.cloudRepoInputs ||
        input.cloudRepoInputs.length < input.maxSelection
      ) {
        <div class="selected-cloud-folder form-inline">
          <div class="form-control d-flex align-items-center">
            <div class="truncate-txt"></div>
          </div>
          <button
            type="button"
            class="xrx-btn btn-secondary ml-2 modal-show-desktop"
            (click)="addChangeCloudInput()"
            xdaTranslate>
            SDE_ADD
          </button>
          <button
            type="button"
            class="xrx-btn btn-secondary btn-short xgl-file_add modal-show-mobile"
            (click)="addChangeCloudInput()"></button>
        </div>
      }
      @if (
        displayErrors &&
        (!input.cloudRepoInputs || input.cloudRepoInputs.length < 1)
      ) {
        <div class="fileinput-error">
          <span
            class="text-danger"
            [xdaTranslate]="'SDE_REQUIRED_FIELD1'"></span>
        </div>
      }
      @if (specialCharactersInCloudFileName) {
        <div class="fileinput-error">
          <span
            class="text-danger"
            [xdaTranslate]="'SDE_CHARACTERS_CANNOT_BE'"
            [formatValues]="'\&quot;?;&lt;&gt;|:\'*%^&amp;#+`\\\/'"></span>
        </div>
      }
    </div>
  </div>
}
